export const isSystemCourseGetter = "is System Course getter";
